import { lf } from '@/api/data/lovefield';
const { STRING, NUMBER, BOOLEAN, OBJECT, OBJECT_ARRAY } = lf.Type;
const AccountColumns = [
    {
        name: 'id',
        type: STRING,
    },
    {
        name: 'originId',
        type: STRING,
    },
    {
        name: 'contactId',
        type: STRING,
    },
    {
        name: 'accountName',
        type: STRING,
    },
    {
        name: 'domain',
        type: STRING,
    },
    {
        name: 'nickName',
        type: STRING,
    },
    {
        name: 'avatar',
        type: STRING,
    },
    {
        name: 'company',
        type: STRING,
    },
    {
        name: 'pwd',
        type: STRING,
    },
    {
        name: 'status',
        type: NUMBER,
    },
    {
        name: 'expired',
        type: BOOLEAN,
    },
    {
        name: 'enabledMobileLogin',
        type: BOOLEAN,
    },
    {
        name: 'token',
        type: STRING,
    },
    {
        name: 'sessionId',
        type: STRING,
    },
    {
        name: 'cookies',
        type: OBJECT_ARRAY,
    },
];
const account = {
    name: 'account',
    global: true,
    using: 'dexie',
    version: 6,
    tables: [
        {
            name: 'subAccount',
            columns: [
                ...AccountColumns,
                {
                    name: 'accountType',
                    type: STRING,
                },
                {
                    name: 'mainAccount',
                    type: STRING,
                },
                {
                    name: 'rowId',
                    type: NUMBER,
                },
                {
                    name: 'mainInfo',
                    type: OBJECT,
                },
            ],
            primaryKey: {
                columns: [{ name: 'rowId', autoIncrement: true }],
            },
            index: [
                {
                    name: 'mainAccount',
                    columns: ['mainAccount'],
                    unique: false,
                    multi: false,
                },
                {
                    name: 'accountType',
                    columns: ['accountType'],
                    unique: false,
                    multi: false,
                },
                {
                    name: 'id',
                    columns: ['id'],
                    unique: false,
                    multi: false,
                },
                {
                    columns: ['mainAccount', 'id'],
                },
            ],
        },
        {
            name: 'account',
            columns: AccountColumns,
            primaryKey: {
                columns: [{ name: 'id', autoIncrement: false }],
            },
            index: [
                {
                    name: 'originAccountIdx',
                    columns: ['originId'],
                    unique: true,
                    multi: false,
                },
            ],
        },
        {
            name: 'accountInfo',
            columns: [
                {
                    name: 'id',
                    type: STRING,
                },
                {
                    name: 'originId',
                    type: STRING,
                },
                {
                    name: 'accountId',
                    type: STRING,
                },
                {
                    name: 'type',
                    type: STRING,
                },
                {
                    name: 'avatar',
                    type: STRING,
                },
                {
                    name: 'accountName',
                    type: STRING,
                },
                {
                    name: 'domain',
                    type: STRING,
                },
                {
                    name: 'isProxy',
                    type: BOOLEAN,
                },
                {
                    name: 'isDefault',
                    type: BOOLEAN,
                },
                {
                    name: 'mobile',
                    type: STRING,
                },
                {
                    name: 'mobileArea',
                    type: STRING,
                },
                {
                    name: 'updateTime',
                    type: NUMBER,
                },
                {
                    name: 'prop',
                    type: OBJECT,
                },
            ],
            primaryKey: {
                columns: [{ name: 'id', autoIncrement: false }],
            },
            index: [
                {
                    name: 'accountIdx',
                    columns: ['accountId'],
                    unique: false,
                    multi: false,
                },
            ],
        },
        {
            name: 'domain',
            columns: [
                {
                    name: 'id',
                    type: STRING,
                },
                {
                    name: 'orgId',
                    type: STRING,
                },
                {
                    name: 'domain',
                    type: STRING,
                },
                {
                    name: 'type',
                    type: NUMBER,
                },
            ],
            primaryKey: {
                columns: [{ name: 'id', autoIncrement: false }],
            },
            index: [
                {
                    name: 'orgIdIdx',
                    columns: ['orgId'],
                    unique: false,
                    multi: false,
                },
                {
                    name: 'domainIdx',
                    columns: ['domain'],
                    unique: false,
                    multi: false,
                },
            ],
        },
        {
            name: 'secCertInfo',
            columns: [
                {
                    name: 'id',
                    type: STRING,
                },
                {
                    name: 'sn',
                    type: STRING,
                },
                {
                    name: 'priKey',
                    type: STRING,
                },
                {
                    name: 'pubKey',
                    type: STRING,
                },
                {
                    name: 'expTime',
                    type: NUMBER,
                },
                {
                    name: 'status',
                    type: NUMBER,
                },
            ],
            primaryKey: {
                columns: [{ name: 'id', autoIncrement: false }],
            },
            index: [
                {
                    name: 'snIdx',
                    columns: ['sn'],
                    unique: false,
                    multi: false,
                },
            ],
        },
    ],
};
export default account;
